<template>
  <div class="custom-control custom-radio">
    <input
        type="radio"
        class="custom-control-input"
        v-bind="{ ...$attrs, onChange: updateValue }"
        :checked="modelValue === value"
        :value="value"
        :id="uuid"
      />
    <label
      v-if="label"
      :for="uuid"
      class="custom-control-label"
    >
      {{ label }}
    </label>
    <ErrorMessage
      v-if="error"
      :id="`${uuid}-error`"
    >
      {{ error }}
    </ErrorMessage>
  </div>
</template>

<script>
import UniqueID from '@/Lib/UniqueID'
import SetupFormComponent from '@/Lib/SetupFormComponent'

export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [String, Number]
    },
    value: {
      type: [String, Number]
    },
    error: {
      type: String,
      default: ''
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup (props, context) {
    const uuid = UniqueID().getID()
    const { updateValue } = SetupFormComponent(props, context)

    return {
      updateValue,
      uuid
    }
  }
}
</script>
